import { planConversionBannerTargetPlanNames } from "./const";

// 選択中の契約コース名が、一括転換コース訴求バナーの表示対象かどうかを判定する
export const isPlanConversionBannerTargetPlan = (planName: string | null | undefined): boolean => {
  if (planName === null || planName === undefined) {
    return false;
  }

  return (planConversionBannerTargetPlanNames as readonly string[]).includes(planName);
};
